export default __webpack_public_path__ + "static/media/chart2.c46cd59a.PNG";